<script setup lang="ts">
import type { severity } from '@/types/informationBanner';

const props = defineProps<{
    severity: severity;
    labelledBy: string;
}>();
</script>

<template>
    <div>
        <div class="alert alert-dismissable fade show mb-0 small d-flex flex-row align-items-center justify-content-between"
            :class="`alert-${severity}`" role="alert" :aria-labelledby="labelledBy">
            <div class="spacer">&nbsp;</div>
            <div class="text-center alert-text" :id="labelledBy">
                <slot c-if="$slots.icon" name="icon"></slot>
                <slot name="message"></slot>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.alert-text {
    width: 66.66666667%;
}
.spacer {
    min-width: 2em;
    width: 2em;
}
.btn-close {
    margin-top: 0;
    --bs-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
    --bs-btn-close-opacity: 1;
}

.alert {
    --bs-alert-color: #fff;
    --bs-alert-border: 0;
    --bs-border-radius: 0;
    text-align: center;
}

.alert-danger {
    --bs-alert-bg: #d41659;
}

.alert-warning {
    --bs-alert-bg: #0077b3;
}

.alert-info {
    --bs-alert-bg: #707070;
}
</style>